import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import {
    ElectionDefinition,
    GetRouteAdTargeting,
    PageType,
} from '@news-mono/web-common'
import { layout } from '../../../App.routing'

type CreateElectionPageArgs = {
    electionDefinition: ElectionDefinition
    getAdTargeting: GetRouteAdTargeting
}

export const createElectionWidgetTestPage = ({
    electionDefinition,
    getAdTargeting,
}: CreateElectionPageArgs): PageType<TheWestSection> => {
    const { electionId } = electionDefinition

    return {
        kind: 'page',
        heading: 'Election Widget Test Page',
        pageType: 'static',
        section: 'default',
        hideHeading: true,
        adTargeting: getAdTargeting('home', 'default', 'home'),
        pageMeta: {
            description: 'Election Widget Test Page',
        },
        socialMeta: {
            description: 'Election Widget Test Page',
        },
        compositions: [
            layout.composition({
                type: 'box',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    fullWidth: true,
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'election-head-to-head-seat-count-widget',
                            props: {
                                electionDefinition,
                            },
                        }),
                        layout.component({
                            type: 'election-navigation',
                            props: {
                                electionDefinition,
                            },
                        }),
                        layout.component({
                            type: 'election-head-to-head-seat-count-widget',
                            props: {
                                electionDefinition,
                            },
                        }),
                        layout.component({
                            type: 'election-the-race-widget',
                            props: {
                                electionDefinition,
                            },
                        }),
                        layout.component({
                            type: 'election-party-totals',
                            props: {
                                electionDefinition,
                                description: `Election Widget Test Page`,
                            },
                        }),
                        layout.component({
                            type: 'election-seat-widget',
                            props: {
                                electionDefinition,
                                electoratePageUrl: `/politics/${electionId}/electorates`,
                            },
                        }),
                        layout.component({
                            type: 'election-full-electorate-widget',
                            props: {
                                electionDefinition,
                                electoratePageUrl: `/politics/${electionId}/electorates`,
                            },
                        }),
                        layout.component({
                            type: 'election-seat-embed-collection-widget',
                            props: {
                                electionDefinition,
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}
